export default {
  label: {
    selectFile: '选择文件',
    noSelectFile: '未选择任何文件',
    companyInfo: '主页',
    employeeCompanyInfo: '员工主页',
    teamInfo: '信息页',
    employeeTeamInfo: '员工信息页',
    pageDisplayedName: '页面/按钮名称',
    aboutUs: '关于我们',
    aboutTeam: '团队介绍',
    addPicture: '添加图片',
    modifyPicture: '修改图片',
    modifyPictureOrVideo: '修改图片/视频',
    labelCompanyName: '公司名称',
    labelSlogan: '标语',
    delete: '删除',
    dragToOrder: '拖动排序',
    sureToDelete: '您确定要删除当前区域么？',
    groupTitle: '标题',
    pleaseInputText: '请输入文字',
    didNotInputText: '还未输入文字信息',
    textDescription: '文字描述',
    pleaseInputLink: '请输入链接地址',
    addGroupPicture: '添加图片',
    suggestUploadPicture: '建议上传的图片尺寸为750*300以下',
    suggestUploadHeaderPicture: '建议上传的图片尺寸为750*360以下，视频仅支持mp4格式，最大10MB',
    atLeastUploadOnrPicture: '至少需要上传一张图片',
    addPictureWallPicture: '添加图片墙图片',
    pictureWillDisplayFlat: '图片将会并排横向排列。建议上传的图片尺寸为300*300以下',
    addVideoCover: '添加视频封面',
    suggestVideoSize: '建议尺寸640*480',
    addVideo: '添加视频',
    suggestVideoSizeAndLength: '建议为标清（640x480，不超过1080x720）1分钟视频',
    playVideo: '播放视频',
    addText: '添加文字',
    addLoopPicture: '添加轮播图',
    addCombinationPicture: '添加组合图',
    addVideoSection: '添加视频',
    text: '文字',
    loopPicture: '轮播图',
    combinationPicture: '图片组合',
    videoSection: '视频',
    add: '添加',
    cancel: '取消',
    preview: '预览',
    save: '保存',
    viewJobs: '查看职位',
    team: '团队',
    headerIsEmpty: '你好像忘记上传页面头部图片啦！',
    msgImageBoard: '这里可以添加1-3张图片。',
    msgSliderBoard: '这里可以添加1-7张图片。',
    msgNoUploadImage: '你好像有图片没有上传噢，请检查一下吧！',
    msgNoCover: '这个视频好像缺少了一个暖心的封面！',
    msgNoVideo: '你好像忘记上传视频啦！',
    msgSaveSuccess: '保存成功。',
    msgSaveErr: '保存失败，请重试一下吧。',
    msgInputMenuName: '你好像忘记填写页面/按钮名称啦！',
    textIsEmpty: '文本内容为空',
    expand: '展开',
    collapse: '收起',
    setPageError: '请先完成员工主页设置。',
    setEmployeePageError: '请先完成主页设置',
    wechatShareJobList: '职位列表页',
    wechatShareJobDetail: '职位详情页',
    wechatShareLogo: '微信分享图标',
    wechatShareUploadLogo: '上传图标',
    wechatShareTitle: '发送给好友标题',
    wechatShareDesc: '发送给好友内容',
    wechatShareMomentTitle: '分享到朋友圈标题',
    wechatShareSettings: '微信分享设置',
    tipMessage: '您可以在这里设置分享到微信朋友和朋友圈的图标及文字。微信分享图标不能小于300px x 300px； 当微信分享的标题或内容中包含占位符#COMPANYNAME#时，分享内容会自动替换该属性。',
    tipMessageForJobDetail: '您可以在这里设置分享到微信朋友和朋友圈的图标及文字。微信分享图标不能小于300px x 300px； 当微信分享的标题或内容中包含这三个占位符：#JOBTITLE#， #JOBLOCATION#， #COMPANYNAME# 时，分享内容会自动替换这些属性。',
    jdSalary: '薪水',
    jobTitle: '职位名称',
    jdRoleType: '工作性质',
    jdExperience: '工作经验',
    jdWorkTime: '工作时间',
    jdWorkLocation: '工作地点',
    jobDetailDescription: '你的职位描述',
    notSpecified: '未设置',
    jobDescTitle: '职位描述个性化',
    isActivatedLabel: '是否激活配置',
    yes: '是',
    no: '否',
    isActivatedPage2Msg: '该配置只有在主页激活时生效。',
    isActivatedPage6Msg: '该配置只有在员工主页激活时生效。',
    landingPageSettings: '页面设置',
    ON: '开',
    OFF: '关',
    jobFilter: '职位列表过滤条件',
    operation: '操作',
    sort: '排序',
    jobListFilter: '定制职位列表过滤器',
    mobile: '手机端',
    pc: '电脑端',
    editCompanyPage: '编辑公司主页',
    videoNavigation: '导览视频',
    customJDDetailFieldTitle: '定制职位详情页显示字段',
    customJDDetailFieldHeader: '职位详情页显示字段',
    buttonSettingsTitle: '按钮设置',
    buttonSettingsLabel: '按钮',
    buttonOperation: '职位详情页可见',
    moduleGap: '区域间隔'
  },
  placeholder: {
  },
  message: {
    filterCountLimitTip: '您最多在职位列表页面选取{count}个过滤器。',
    wrongPhotoFileType: '请确认图片是以下类型: jpeg, jpg, png, gif',
    wrongHeaderFileType: '请确认文件是以下类型: jpeg, jpg, png, gif, mp4',
    wrongHeaderVideoFileSize: '请确认视频大小不超过{fileSize}MB'
  }
}
